import raw from './raw.json'
import {Country} from "./types"

const countries: Country[] = raw.countries

export default countries